import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import video1 from "../../../assets/videos/Add_case.mp4";
import "./HubspotModel.css";

const MessagePopup = ({ messageBox, closeMessageBox, messageContent }) => {

    console.log(messageBox);
    console.log("message box");
  return (
    <>
      <Modal
        className="video-modal modal-box"
        open={messageBox}
        onClose={closeMessageBox}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modal-dialog">
          {/* <button type="button" className="btn-close"><span className="material-icons-outlined">close</span> Close</button> */}
          <div className="modal-body">
                <div dangerouslySetInnerHTML={{ __html: messageContent }} /> {/* Render as HTML */}
          </div>
        </div>
      </Modal>
    </>
  );
};
export default MessagePopup;
